import styled from 'styled-components';

import { colorsPalettes, setFontVariant } from '@similarweb/styles';

export const ToastView = styled.div<{ isInfoIcon?: boolean }>`
  min-width: 404px;
  min-height: 56px;
  padding: 10px 12px;
  background-color: ${colorsPalettes.midnight[500]};
  border-radius: 4px;
  position: fixed;
  bottom: 8px;
  left: 50%;
  transform: translate(-50%);
  z-index: 9999;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

export const ToastContent = styled.p`
  ${setFontVariant('input2', colorsPalettes.carbon[0])};
  margin: 0;
  flex: 1;
`;

export const StyledToastLink = styled.a`
  ${setFontVariant('button', colorsPalettes.carbon[0])};
  text-decoration: none;
  margin: 0;
  flex: none;
  cursor: pointer;
`;

export const ToastMainContent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
`;

export const StyledCloseButton = styled.button`
  background: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: none;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  padding: 8px;
  line-height: 10px;
  border: none;
  box-shadow: none;
  transition: background-color 0.2s ease-in-out;

  &:hover {
    background-color: rgba(181, 190, 198, 0.2);
  }
`;

export const StyledSuccessLottieContainer = styled.div`
  width: 40px;
  height: 40px;
`;
